export default __webpack_public_path__ + "static/media/airstrapz-wht-2.115c4ebc.png";